import React from 'react';
import { GeoJSON, Popup } from 'react-leaflet';

const COLORS = ['#0369a1', '#7c3aed', '#047857', '#b45309', '#be123c'];

function colorFor(layerId) {
  const hash = String(layerId || '').split('').reduce((value, character) => value + character.charCodeAt(0), 0);
  return COLORS[hash % COLORS.length];
}

export default function ManagedGeographyLayer({ layer, data, interactive = true, onFeatureSelect, selectedIds = [] }) {
  if (!data?.features?.length) return null;
  const color = colorFor(layer.layerId || layer._id);

  return data.features.map((feature, index) => (
    <GeoJSON
      key={`${layer._id}-${feature.id || index}-${interactive}-${!!onFeatureSelect}-${selectedIds.includes(String(feature.properties?.featureId))}`}
      data={feature}
      interactive={interactive}
      style={{
        color: selectedIds.includes(String(feature.properties?.featureId)) ? '#2563eb' : color,
        weight: selectedIds.includes(String(feature.properties?.featureId)) ? 4 : 2,
        opacity: 0.85, fillColor: color,
        fillOpacity: selectedIds.includes(String(feature.properties?.featureId)) ? 0.35 : 0.08,
      }}
      onEachFeature={(item, leafletLayer) => {
        if (interactive && item.properties?.name) {
          const label = document.createElement('span');
          label.textContent = String(item.properties.name);
          leafletLayer.bindTooltip(label, { sticky: true });
        }
      }}
      eventHandlers={interactive && onFeatureSelect ? { click: () => onFeatureSelect({
        id: String(feature.properties.featureId), name: feature.properties.name,
      }) } : undefined}
    >
      {interactive && !onFeatureSelect && <Popup>
        <div style={{ lineHeight: 1.5, fontSize: 12 }}>
          <strong>{feature.properties?.name || layer.displayName}</strong>
          {feature.properties?.featureId && <div>{feature.properties.featureId}</div>}
          <div style={{ color: '#64748b' }}>{layer.displayName}</div>
        </div>
      </Popup>}
    </GeoJSON>
  ));
}